module.exports = __webpack_public_path__ + "img/export_xls.31ec6887.svg";